import React, { useState } from "react";

const Contact = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowPopup(true);
  };

  return (
    <div className="pt-24 px-6 md:px-12 bg-[#030303] min-h-screen bg-gradient-to-b from-[#030303] via-[#101010] to-[#030303]">
      {/* Success Popup */}
      {showPopup && (
        <div className="fixed top-0 left-0 right-0 bg-green-500 text-white text-center py-4 z-50 shadow-lg">
          Message sent successfully!
          <button
            onClick={() => setShowPopup(false)}
            className="ml-4 bg-white text-green-500 px-3 py-1 rounded hover:bg-gray-200 transition"
          >
            Close
          </button>
        </div>
      )}
      {/* Hero Section */}
      <section className="text-center mb-16">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Get in <span className="text-blue-600">Touch</span>
        </h1>
        <p className="text-white max-w-2xl mx-auto text-lg opacity-90">
          Have a question, project idea, or just want to say hello?  
          We’d love to hear from you anytime.
        </p>
      </section>

      {/* Contact Form + Info */}
      <section className="grid md:grid-cols-2 gap-10 mb-20">
        {/* Contact Form */}
        <div className="p-8 rounded-2xl shadow-2xl backdrop-blur-lg bg-white/10 border border-white/10 transition-all duration-500 hover:bg-white/15 hover:shadow-blue-500/20">
          <h2 className="text-2xl font-bold text-white mb-6">Send us a Message</h2>
          <form className="space-y-5" onSubmit={handleSubmit}>
            <div>
              <label className="text-white mb-1 font-medium block">Full Name</label>
              <input
                type="text"
                placeholder="Enter your full name"
                required
                className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 outline-none backdrop-blur-sm"
              />
            </div>

            <div>
              <label className="text-white mb-1 font-medium block">Email Address</label>
              <input
                type="email"
                placeholder="Enter your email"
                required
                className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 outline-none backdrop-blur-sm"
              />
            </div>

            <div>
              <label className="text-white mb-1 font-medium block">Subject</label>
              <input
                type="text"
                placeholder="Enter subject"
                required
                className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 outline-none backdrop-blur-sm"
              />
            </div>

            <div>
              <label className="text-white mb-1 font-medium block">Message</label>
              <textarea
                rows="5"
                placeholder="Write your message..."
                required
                className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 outline-none backdrop-blur-sm"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600/90 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-all duration-300 shadow-md hover:shadow-blue-500/40"
            >
              Send Message
            </button>
          </form>
        </div>

        {/* Company Info */}
        <div className="flex flex-col justify-center text-white p-8 rounded-2xl backdrop-blur-lg bg-white/10 border border-white/10 shadow-2xl hover:shadow-blue-500/20 transition-all duration-500">
          <h2 className="text-2xl font-bold mb-6">Contact Information</h2>
          <p className="text-blue-100 mb-8">
            Reach out to us through any of the following ways. We’ll respond as soon as possible.
          </p>
          <div className="space-y-5">
            <div>
              <h3 className="text-lg font-semibold">📍 Address</h3>
              <p className="text-blue-100">University Of Okara, Okara, Pakistan</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold">📞 Phone</h3>
              <p className="text-blue-100">+92 3073040088</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold">📧 Email</h3>
              <p className="text-blue-100">ezeeta@gmail.com</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold">🕓 Working Hours</h3>
              <p className="text-blue-100">Mon – Fri: 9:00 AM – 6:00 PM</p>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex gap-4 mt-8">
            <a
              href="https://www.facebook.com"
              className="bg-blue-600/80 hover:bg-blue-700 p-3 rounded-full transition transform hover:scale-105 shadow-md hover:shadow-blue-400/40"
            >
              <i className="fab fa-facebook-f text-white"></i>
            </a>
            <a
              href="https://www.twitter.com"
              className="bg-blue-600/80 hover:bg-blue-700 p-3 rounded-full transition transform hover:scale-105 shadow-md hover:shadow-blue-400/40"
            >
              <i className="fab fa-twitter text-white"></i>
            </a>
            <a
              href="https://www.linkedin.com"
              className="bg-blue-600/80 hover:bg-blue-700 p-3 rounded-full transition transform hover:scale-105 shadow-md hover:shadow-blue-400/40"
            >
              <i className="fab fa-linkedin-in text-white"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Google Map Embed */}
      <section className="mb-20">
        <h2 className="text-center text-2xl font-bold text-white mb-8">
          Find Us on the Map
        </h2>
        <div className="rounded-2xl overflow-hidden shadow-lg border border-white/10">
          <iframe
            title="Company Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d217865.2859450931!2d74.22950210268791!3d31.58204532623039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3919038d4a8a6b11%3A0xdeb6b01f58c7874a!2sLahore%2C%20Pakistan!5e0!3m2!1sen!2s!4v1679851533767!5m2!1sen!2s"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Contact;
